<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid style="margin-top: 5%;">
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6">
					<h3>Manage Zones</h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<b-button variant="dark" pill class="mr-2" @click="showAddModal()">Add Zone</b-button> 
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-3">
							<b-col lg="6">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<template v-slot:cell(ulb_id)="row">
										<b-label>{{getUlbLabel(row.value)[0].title}}</b-label>
									</template>
                                    <template v-slot:cell(status)="row">
										<b-badge pill variant="danger" v-if="row.value == 0">INACTIVE</b-badge>
										<b-badge pill variant="success" v-else>ACTIVE</b-badge>
									</template>
									<template v-slot:cell(actions)="row">
										<b-button pill variant="primary" class="mr-1" @click="showUpdateModal(row.item, row.index, $event.target)" size="sm">EDIT</b-button>
										<b-button pill variant="danger" class="mr-1" @click="showDeleteModal(row.item)" size="sm">DELETE</b-button>
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>

			
			<b-modal id="my-model" :title="(selectedItem.id > 0)?'Edit Ward | ULB':'Add Ward'" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
				<form ref="form" @submit.stop.prevent="handleSubmit">
					<b-form-group label="State" label-for="fp-input" label-cols="3" label-size="sm" label-align-sm="right" >
						<b-form-select v-model="selectedItem.state_id" :options="$root.state_options" required></b-form-select>
					</b-form-group>
					<b-form-group label="Zone | ULB" label-for="title" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-select v-model="selectedItem.ulb_id">
							<b-form-select-option v-for="item in filterULB(zones)" v-bind:key="item.id" :value="item.id" >{{item.title}}</b-form-select-option>
						</b-form-select>
					</b-form-group>
					<b-form-group label="Name" label-for="title" label-cols="3" label-size="sm" label-align-sm="right" invalid-feedback="Title is required">
						<b-form-input v-model="selectedItem.title" required></b-form-input>
					</b-form-group>
					<b-form-group label="Ward Code" label-for="areacode" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-input v-model="selectedItem.areacode" required></b-form-input>
					</b-form-group>
					<b-form-group label="Status" label-for="status" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-select v-model="selectedItem.status" :options="statusOptions" required></b-form-select>
					</b-form-group>
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
	</div>
	
</template>
<script>
import Header from "@/components/Header.vue";
export default {
	name: 'Wards',
	components: {
		"top-header": Header
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
        this.loadzones()
		this.initload();
	},
	data() {
		var self = this;
		return{
			loading: true, 
			email: '',
			password: '',
            zonesUrl: self.$session.get('apiurl')+'kmrlapi/zone-list',
			recordUrl: self.$session.get('apiurl')+'kmrlapi/zones',
			insertUrl: self.$session.get('apiurl')+'kmrlapi/zone-add',
			updateUrl: self.$session.get('apiurl')+'kmrlapi/zone-edit',
			deleteUrl: self.$session.get('apiurl')+'kmrlapi/zone-remove',
            zones: [],
			records: [],
			statusOptions: [{ value: 0, text: 'Disabled' },{ value: 1, text: 'Enabled' }],
			zoneOptions: [],
			fields: [
				{ key: 'id', label: 'ID'},
				{ key: 'title', label: 'Name'},
				{ key: 'ulb_id', label: 'Urban Load Balance (ULB)',
                    formatter: (value) => {
						return value;
					},
                },
				{ key: 'areacode', label: 'Zone Code' },
				{ key: 'status', label: 'Status' },
				{ key: 'actions', label: 'Actions', class:"text-right", 'extra': 1 }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {},
			emptyItem: {
				id: 0,
                ulb_id: '',
				title: '',
				areacode: '',
				status: 0
			}
		};
	},
	methods: {
        getUlbLabel: function(value){
            return this.zones.filter(function (item) {
				return item.id  == value;
			})
        },
		filterULB: function (items) {
			var self = this;
			return items.filter(function (item) {
				return item.state  == self.selectedItem.state_id;
			})
		},
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-model');
		},
		showUpdateModal(item, index, button) {
			var self = this;
            this.selectedItem = Object.assign({}, item);
            
            var zoneinfo = self.zones.filter(function (zone) {
              //  console.log(item.ulb_id+" "+zone.id);
                if(item.ulb_id == zone.id){
                    return zone;
                }
            });
            
            this.selectedItem.state_id = zoneinfo[0].state;
			this.$root.$emit('bv::show::modal', 'my-model', button)
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete Zone or ULB.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						deleteid: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				alert(err);
				//console.log(err);
			})
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.insertUrl;
			}else{
				submitUrl = self.updateUrl;
			}


			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('my-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
        loadzones(){
			var self = this;
			
			self.axios.post(self.zonesUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.zones = response.data.result;
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//var filteredarr = self.filtercategory(response.data.result);

					self.records = response.data.result;
					self.loading = false;
					self.totalRows = self.records.length;

					/*const zoneOptions = arr.reduce((acc, current) => {
						const x = acc.find(item => item.value === current.value);
						if (!x) {
							return acc.concat([current]);
						} else {
							return acc;
						}
					}, []);*/
					self.zoneOptions = [];
					self.records.forEach(function(item){
						if(item.parent == 0){
							self.zoneOptions.push({value:item.id, text:item.title, state:item.state});
						}
						
					});
					
				}
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		/*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "zone_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		}
	}
}
</script>
<style>
html{
	min-height: 100%;
}
body{
	background-color: '#FFF' !important;
	background-image: none !important;
}
.table{
	font-size: small;
}
.table .btn{
	font-size: 12px;
}
.table td, .table th{
	vertical-align: middle;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
</style>